/** Verified parent release gate for CONTXT v2.13.0 (Prod default off). */
export const RELEASE_GATE_V2_13_0 = 'contxt-v2.13.0'

/** Verified parent release gate for CONTXT v2.13.4 (Prod default off). */
export const RELEASE_GATE_V2_13_4 = 'contxt-v2.13.4'
